module.exports = "/::ng-deep#tree-list-demo {\n    min-height: 530px;\n}\n\n::ng-deep #employees {\n   max-height: 530px;\n}"